import { HStack, Icon, Text } from '@chakra-ui/react';
import { Switch } from '@components/ui/switch';
import { useAppSelector } from '@hooks/redux.hooks';
import { useWithDispatch } from '@hooks/useWithDispatch';
import { hasRole, hasSensorRoleFromActiveProfile } from '@redux/authent/authent.selectors';
import { updateLocalMapFilters } from '@redux/settings/settings.reducer';
import { selectLocalMapFilterByKey } from '@redux/settings/settings.selectors';
import { useIntl } from 'react-intl';

import { RoleEnum } from '@/types/authent/roles.types';
import { ActionEnum } from '@/types/commons/commons.types';
import { FilterOption } from '@/types/filters.types';

type Props = {
  filterOption: FilterOption;
  color?: string;
};

function FiltersMenuItem({ filterOption, color }: Readonly<Props>) {
  const { formatMessage } = useIntl();
  const isChecked = useAppSelector((state) => selectLocalMapFilterByKey(state, filterOption.key));
  const canEditMapFilters = useAppSelector((state) => hasRole(state, RoleEnum.EDIT_MAP_FILTERS));
  const canSeeFilter = useAppSelector((state) => hasRole(state, filterOption.role));
  const canAccessSensor = useAppSelector((state) =>
    hasSensorRoleFromActiveProfile(state, { action: ActionEnum.ACCESS, sensorFamily: filterOption.sensorFamily }),
  );
  const setMapFilters = useWithDispatch(updateLocalMapFilters);

  if ((filterOption.sensorFamily && !canAccessSensor) || (filterOption.role && !canSeeFilter)) {
    return null;
  }

  const handleSwitchChange = () => {
    setMapFilters({ [filterOption.key]: !isChecked });
  };

  return (
    <HStack width="100%" alignItems="start">
      <Switch checked={isChecked} size="md" onCheckedChange={handleSwitchChange} disabled={!canEditMapFilters}>
        {filterOption.Image && <Icon as={filterOption.Image} boxSize="24px" color={color} />}
        <Text textStyle="md" color={canEditMapFilters ? undefined : 'neutral.500'}>
          {formatMessage({ id: filterOption.label })}
        </Text>
      </Switch>
    </HStack>
  );
}

export default FiltersMenuItem;
